const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignChargeStations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M471.953 197.863a39.922 39.922 0 0 0-17.746-33.235l-175.98-117.82c-13.52-9.046-30.985-9.046-44.504 0l-175.98 117.82a39.93 39.93 0 0 0-17.746 33.235v294.14c0 11.043-8.953 19.996-19.996 19.996-11.047 0-20-8.953-20-19.996v-294.14c0-26.742 13.269-51.59 35.488-66.469l175.984-117.82c27.031-18.097 61.972-18.097 89.003 0l175.98 117.82c22.227 14.879 35.493 39.727 35.493 66.469 0 11.043-8.954 19.996-20 19.996-11.043 0-19.996-8.953-19.996-19.996Z",
    style: {
      fill: "#d73a1f"
    },
    transform: "matrix(.03906 0 0 .03906 1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.732 226.75c-17.855 9.644-33.702 22.635-46.034 38.277h-60.069c-16.821.707-30.295 8.388-36.793 19.996l-13.871 24.996h83.413l-8.595 27.663-1.245 12.333h-73.721c-22.553 1.006-38.828 15.627-38.828 33.461v58.531h74.531l16.629-24.297a19.995 19.995 0 0 1 16.503-8.699h7.465c6.243 27.602 19.458 52.596 38.402 72.992H172.864v10c0 10.169-7.593 18.567-19.997 19.996H99.993c-11.047 0-20-8.953-20-19.996V383.476c0-18.395 7.308-35.215 19.339-48.118a20.5 20.5 0 0 1 1.004-2.105l37.563-67.703c14.011-25.019 41.48-40.519 71.73-40.519h92.66l13.443 1.719Z",
    style: {
      fill: "#d73a1f"
    },
    transform: "matrix(.03906 0 0 .03906 1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.985 377.015c-11.047 0-20 8.953-20 19.996 0 11.047 8.953 20 20 20 11.043 0 19.996-8.953 19.996-20 0-11.043-8.953-19.996-19.996-19.996Z",
    style: {
      fill: "#d73a1f"
    },
    transform: "matrix(.03906 0 0 .03906 1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.8 437.1c-152.6 0-276.6 123.8-276.7 276.3C419 866.1 543.2 990.1 696.2 990c152.2-.1 276.2-123.9 276.4-276.1.3-152.7-123.9-276.7-276.8-276.8Zm182.5 197-219 221.8c.2-.3.5-.6.7-.9-7.2 7.8-13-.6-12.7-.3L503 711.4c-4.7-4.7-4.7-12.4 0-17.2l34.5-35.1c4.7-4.7 12.4-4.7 17.2 0l100 100 172.5-175.9c4.7-4.7 12.3-4.7 16.9 0l33.9 33.9c4.7 4.7 4.7 12.3 0 16.9h.3v.1Z",
    style: {
      fill: "#d73a1f",
      fillRule: "nonzero"
    },
    transform: "matrix(.01807 0 0 .01807 4.178 2.603)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignChargeStations);
export default __webpack_public_path__ + "static/media/assign-charge-stations.a631fef582691f0e67964f051a5d3fc7.svg";
export { ForwardRef as ReactComponent };